import { createAction } from "../../utils/redux/createAction";
import { UPDATE_FACTSHEET_DATA } from "./types";
import { IFactsheetState, IAction } from "../../ts/redux";

export function updateFactsheetData(payload: IFactsheetState): IAction {
    return createAction(UPDATE_FACTSHEET_DATA, payload);
}